import { createSelector } from "starfx";

import { schema } from "../schema";

import type { TWhoami } from "../schema/app.def";

export const selectorWorkerGxDBName = createSelector(
  schema.whoami.select,
  (who: TWhoami) => {
    if (!who.AmaId || !who.wai_database) return null;
    const indexDbName = `w.${who.AppIsPersonalKarma ? "K" : "J"}${who.AmaId}.${
      who.wai_database
    }`; //w.J16.SWCRE//
    return indexDbName;
  }
);
